import { type DevScenarioEntry, devScenarioEntry, mockApiError } from '@arya/shared/msw-cloudflare';

export const ACCOUNT_SCENARIOS: readonly DevScenarioEntry[] = [
  devScenarioEntry(
    {
      name: 'portfolio-500',
      group: 'Portfolio',
      title: 'Server error',
      description: 'Holdings fail to load: the portfolio and holding pages show an error with Try again.',
      screen: '/account/portfolio',
    },
    { method: 'GET', path: '/api/account/portfolio/holdings' },
    () => mockApiError(500, 'boom')
  ),
  devScenarioEntry(
    {
      name: 'notifications-500',
      group: 'Notifications',
      title: 'Server error',
      description: 'The bell dialog and the notification history fail to load.',
      screen: '/account/notifications',
    },
    { method: 'GET', path: '/api/account/notifications' },
    () => mockApiError(500, 'boom')
  ),
  devScenarioEntry(
    {
      name: 'identity-widget-500',
      group: 'Identity verification',
      title: 'Widget unavailable',
      description: 'Starting verification cannot load the verification widget: error with Try again.',
      screen: '/onboarding/identity',
    },
    { method: 'GET', path: '/api/kyc/sumsub-token' },
    () => mockApiError(500, 'boom')
  ),
  devScenarioEntry(
    {
      name: 'questionnaire-500',
      group: 'Suitability questionnaire',
      title: 'Server error',
      description: 'The questions fail to load: error banner on the questionnaire.',
      screen: '/onboarding/suitability?step=questions',
    },
    { method: 'GET', path: '/api/account/knowledge-test/questions' },
    () => mockApiError(500, 'boom')
  ),
];
